import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { ADD, EDIT, IDLE, PENDING, PUBLISHED } from "const"
import { StateType, hasProjectAccess } from "client/utils"
import {
    PRM_STUDY,
    StoreType,
    StudyProps,
    RrsCategoryList,
    ProjectUserList,

    LoadAllRrsCategories,
    LoadProjectUsers,
    LoadStudyById,
    PrepareRrsCategoryNestedIds,

    setRrsCategoryList,
    setRrsCategoryChildParent,
    setProjectUserList,
    setStudyEdit,
    setStudyReloadEdit,
    initStudy,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
    TableNestedIds,
} from "client/components"

import NotFound from "client/parts/notFound"
import AccessDenied from "client/parts/accessDenied"
import Form from "./form"

const Edit = ({
    studyId = null,
}: StudyProps) => {
    const study = useSelector((state: StoreType) => state.study.studyEdit)
    const reloadEdit = useSelector((state: StoreType) => state.study.reloadEdit)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const accountSettings = useSelector((state: StoreType) => state.system.accountSettings)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setStudyReloadEdit(false))
        setTimeout(() => {
            dispatch(setStudyReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        const promiseArray: Promise<any>[] = []
        // for selecting "systemStage" and "status" category
        if (accountSettings.rrs.defaultCategoriesAssigned) {
            promiseArray.push(
                LoadAllRrsCategories(userData.accountId, null).then((res) => {
                    dispatch(setRrsCategoryList(res.categoryList))
                    dispatch(setRrsCategoryChildParent(res.childParent))
                }),
            )
        } else {
            promiseArray.push(
                LoadAllRrsCategories(1, null).then((res) => {
                    const groupedIds = PrepareRrsCategoryNestedIds(Object.values(res.categoryList))
                    let nestedIds = groupedIds.length ? groupedIds[0].nestedIds : []

                    // show only published from Super Admin
                    nestedIds = nestedIds.filter((row) => {
                        const category = res.categoryList[Number(row.id)]
                        return category.status === PUBLISHED
                    })

                    const publishedCategoryList: RrsCategoryList = {}
                    const addToList = (nested: readonly TableNestedIds[]) => {
                        nested.forEach((row) => {
                            const id = Number(row.id)
                            publishedCategoryList[id] = res.categoryList[id]
                            addToList(row.nestedIds)
                        })
                    }
                    addToList(nestedIds)

                    dispatch(setRrsCategoryList(publishedCategoryList))
                    dispatch(setRrsCategoryChildParent(res.childParent))
                }),
            )
        }
        // for selecting manager
        promiseArray.push(
            LoadProjectUsers(project.id).then((res) => {
                const newProjectUserList: ProjectUserList = { [project.id]: res }
                dispatch(setProjectUserList(newProjectUserList))
            }),
        )

        if (studyId === 0) {
            dispatch(setStudyEdit(initStudy))
        } else {
            promiseArray.push(
                LoadStudyById(studyId, project.id).then((res) => {
                    dispatch(setStudyEdit(res))
                }),
            )
        }

        setLoadState(PENDING)
        Promise.all(promiseArray).then(() => {
            setLoadState(IDLE)
            reload()
        })
    }, [])

    const addAccess = hasProjectAccess(PRM_STUDY, ADD)
    const editAccess = hasProjectAccess(PRM_STUDY, EDIT)

    if (studyId === 0 && !addAccess) return <AccessDenied />
    if (studyId !== 0 && !editAccess) return <AccessDenied />
    if (!study) return <NotFound />

    return (
        <Container>
            <PageHeader>
                <PageTitle>{study.id ? `${lang.editStudy} # ${study.id}` : lang.addStudy}</PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form study={study} />
                }
                {
                    reloadEdit
                    && <Form study={study} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
